<div class="relative inline-block">
    <button (click)="isOpen = !isOpen"
            class="relative w-10 h-10 flex items-center justify-center rounded-xl
                   text-gray-500 hover:text-blue-600 hover:bg-blue-50
                   transition-all duration-200 cursor-pointer">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
        </svg>
        @if((notificationService.unreadCount$ | async)! > 0) {
            <span class="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] flex items-center justify-center
                         px-1 text-[10px] font-bold text-white bg-rose-500 rounded-full
                         ring-2 ring-white animate-pulse">
                {{ notificationService.unreadCount$ | async }}
            </span>
        }
    </button>

    @if(isOpen) {
    <div class="absolute right-0 mt-2 w-80 rounded-2xl overflow-hidden z-[100]
                bg-white/95 backdrop-blur-xl border border-gray-100
                shadow-[0_8px_30px_rgba(0,0,0,0.12)] animate-scale-in">
        <div class="p-4 bg-gradient-to-r from-gray-50 to-slate-50 border-b border-gray-100
                    flex justify-between items-center">
            <span class="font-semibold text-gray-700">Notifications</span>
            <button (click)="isOpen = false"
                    class="w-6 h-6 flex items-center justify-center rounded-lg
                           text-gray-400 hover:text-rose-500 hover:bg-rose-50
                           transition-all cursor-pointer">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
        </div>
        <ul class="max-h-80 overflow-y-auto custom-scrollbar divide-y divide-gray-100">
            @for(notif of notificationService.notifications$ | async; track notif.id) {
                <li (click)="markRead(notif)"
                    class="p-4 hover:bg-blue-50 cursor-pointer transition-all duration-200"
                    [ngClass]="{'bg-blue-50': !notif.isRead}">
                    <div class="flex gap-3">
                        <div class="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
                             [class.bg-blue-100]="!notif.isRead"
                             [class.bg-gray-100]="notif.isRead">
                            <svg class="w-4 h-4" [class.text-blue-600]="!notif.isRead" [class.text-gray-400]="notif.isRead"
                                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
                            </svg>
                        </div>
                        <div class="flex-1 min-w-0">
                            <p class="text-sm text-gray-800 font-medium line-clamp-2">{{ notif.content }}</p>
                            <p class="text-xs text-gray-400 mt-1">{{ notif.createdAt | date:'short' }}</p>
                        </div>
                        @if(!notif.isRead) {
                            <span class="w-2 h-2 bg-blue-500 rounded-full shrink-0 mt-2"></span>
                        }
                    </div>
                </li>
            }
            @empty {
                <li class="p-8 text-center">
                    <div class="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-100 flex items-center justify-center">
                        <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
                        </svg>
                    </div>
                    <p class="text-gray-400 text-sm">No notifications yet</p>
                </li>
            }
        </ul>
    </div>
    }
</div>
